import { AxiosResponse } from 'axios';
import {
  IChartData,
  IDashboard,
  IGetChartDataOptions,
} from 'common/types/dasboard';

import { $host } from './index';

export const getDashboard = async (startDate: string, endDate: string) => {
  const { data } = await $host.get<AxiosResponse<IDashboard>>(
    '/admin/dashboard/date-range',
    {
      params: {
        startDate,
        endDate,
      },
    },
  );

  return data;
};

export const getChartData = async ({
  startDate,
  endDate,
  metric,
  interval,
}: IGetChartDataOptions) => {
  const { data } = await $host.get<AxiosResponse<IChartData>>(
    '/admin/dashboard/chart-data',
    {
      params: {
        startDate,
        endDate,
        metric,
        interval,
      },
    },
  );

  return data;
};
